if($('header#header').length){
  $('.header-top .container').append('<div class="phone">'+$('footer#footer .contact-box .tel').clone().html()+$('footer#footer .contact-box .cellphone').clone().html()+'</div>')  
  /*$(document).on("ready resizeEnd", function() {
     $('.contact-menu').remove(), detectResolution(767) || $(".navigation-in .menu-level-1").append('<ul><li class="contact-menu">'+$('.top-navigation-contacts').html()+'</li></ul>')
  })*/
  $('#customerLogin input[name="email"]').attr('placeholder', '').before('<label for="email">'+loginacount+'<span>*</span></label>')
	$('#customerLogin input[name="password"]').attr('placeholder', '').before('<label for="password">'+loginpasword+'<span>*</span></label>')
  $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner');
  $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
    $('body').removeClass('user-action-visible login-window-visible')
  })
  if($('.top-navigation-tools a[href="/klient/"]').length){
    $('.navigation-buttons').append('<a href="/login/?backTo=%2Fprodejna%2F" class="" data-target="login-ucet" rel="nofollow"><span>Přihlášení</span></a>')
  }
  $('.login-widget').prepend($('footer#footer .registrace-box').clone())
  $('.navigation-buttons').append($('.top-navigation-bar .top-navigation-tools .dropdown')).append($('.top-navigation-bar .top-navigation-tools a[data-target="login"]'))
  $('input[type="search"]').attr('placeholder', 'Jaké barefoot boty hledáte?')
  $('header nav#navigation .menu-level-1 li').each(function(){
    findli = $(this).find('>a').attr('href')
    findli = findli.replace(/\//g, '')
    $(this).closest('li').addClass(findli)
  })
  if($('#footer').length == 0){
    $('header#header .phone').html('<div class="telphone"></div><div class="cellphone"></div>')
    if (!sessionStorage.mhphone) {
      $(document).on("ready", function(){
        $("header .telphone").load("/ footer#footer .contact-box .tel a", function(){
          sessionStorage.mhphone = $("header .telphone").html();
        });
      })
    } else {
      $("header .telphone").append(sessionStorage.mhphone);
    };
    if (!sessionStorage.mhcellphone) {
      $(document).on("ready", function(){
        $("header .cellphone").load("/ footer#footer .contact-box .cellphone a", function(){
          sessionStorage.mhcellphone = $("header .cellphone").html();
        });
      })
    } else {
      $("header .cellphone").append(sessionStorage.mhcellphone);
    };
  }
}

